import React, { useEffect, useState } from 'react';

const LABELS = {
    SHIP_FROM_HERE: 'Ship from here',
    BB_UNDERCUT_BELOW_MAP: 'Undercut below MAP',
    OUT_OF_STOCK: 'Out of stock',
    RUNNING_LOW: 'Running low',
    LOSING_OUTSIDE_COVERAGE: 'Losing sales outside our warehouses',
    BB_SLOWER: 'Slower than competitor',
    BB_TIED: 'Tied — ties go to the winner',
    LISTING_MISSING: 'Offer missing',
    BB_PRICED_ABOVE: 'Priced above Buy Box',
    NOT_SELLING_NOT_PLACEMENT: 'Not selling — not placement',
    BB_UNKNOWN_CAUSE: 'Losing Buy Box',
    GUARD_LOW_MARGIN: 'Low margin',
    COVERAGE_LOW_SALES_NORMAL: 'Coverage low, sales normal',
    CANT_TELL: "Can't tell",
    IN_TRANSFER: 'Amazon moving stock',
    SPREAD_BELOW_TARGET: 'Spread below target',
    REGION_LOW: 'Region running low',
    SPREAD_EXCLUDED: 'Spread n/a',
    COVERAGE_SIZED: 'Sized for coverage',
    OVERSTOCK: 'Overstock',
    PRICE_LOSS_NO_ORDER: 'Not ordered — Buy Box lost on price',
    RANK_ABOVE_CEILING: 'Not ordered — rank above ceiling',
};

const KIND_CLASS = {
    STOCK: 'bg-red-100 text-red-800',
    PLACEMENT: 'bg-blue-100 text-blue-800',
    BUYBOX: 'bg-purple-100 text-purple-800',
    GUARD: 'bg-gray-200 text-gray-800',
    INFO: 'bg-gray-100 text-gray-600',
};

export default function ReasonChips({ reasons }) {
    const driverIdx = (reasons || []).findIndex(r => r.driver);
    const [open, setOpen] = useState(driverIdx >= 0 ? driverIdx : 0);
    // A new reasons list (refetch, other row) re-opens its driver, so a shorter list never points
    // past its end and shows a blank sentence.
    useEffect(() => { setOpen(driverIdx >= 0 ? driverIdx : 0); }, [reasons]);   // eslint-disable-line react-hooks/exhaustive-deps
    if (!reasons || reasons.length === 0) return <span className="text-xs text-gray-400">No reorder needed</span>;
    return (
        <div className="max-w-md">
            <div className="flex flex-wrap gap-1">
                {reasons.map((r, i) => (
                    <button key={r.code} type="button" onClick={() => setOpen(i)}
                            className={`px-2 py-0.5 rounded-full text-xs ${KIND_CLASS[r.kind] || KIND_CLASS.INFO} ${r.driver ? 'font-bold ring-1 ring-current' : ''}`}
                            title={r.sentence}>
                        {LABELS[r.code] || r.code}
                    </button>
                ))}
            </div>
            <p className="mt-1 text-xs text-gray-700 whitespace-normal">{reasons[open]?.sentence}</p>
        </div>
    );
}
